(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('EmploieTempsSearch', EmploieTempsSearch);

    EmploieTempsSearch.$inject = ['$resource'];

    function EmploieTempsSearch($resource) {
        var resourceUrl = 'api/_search/emploie-temps/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
